let map;

async function initMap( $el ) {
    const { Map } = await google.maps.importLibrary("maps");

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom: $el.data('zoom') || 8,
        mapId: '86ba7a64135bec9f',
        disableDefaultUI: true,
        // gestureHandling: 'none',
        zoomControl: false
    };
    var map = new Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {
    // const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var numberLabel = $marker.data('number');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };
    var customLabel = {
        text: numberLabel.toString(),
        className: "marker-label",
        color: "#FFF",
        fontFamily: 'Cubano',
        fontSize: '36px',
        
    }
    var svgMarker = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 20,
        fillColor: "#6AA444",
        fillOpacity: 1,
        strokeWeight: 0
    }

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        label: customLabel,
        icon: svgMarker,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).on('ready', function(){
    $('.branch-map').each(function(){
        var map = initMap( $(this) );
    });
});